<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="custom-code__header">
      <div class="card__title-block">
        <pdq-heading element="h5">Custom code</pdq-heading>
        <span class="card__subtitle">if enabled, the custom template will be used instead of the default one</span>
      </div>
      <div class="custom-code__actions">
        @if (enabledControl.value) {
          <pdq-button label="Edit code" variant="secondary" size="medium" (onClick)="onEditCode()"></pdq-button>
        }
        <pdq-slide-toggle
          [defaultValue]="enabledControl.value"
          (onToggle)="enabledControl.setValue($event)"></pdq-slide-toggle>
      </div>
    </div>
  </div>
</pdq-card>
